import React , { useState } from 'react'
import { addDoc , collection, getFirestore} from 'firebase/firestore'
import { initializeApp } from 'firebase/app'
import Swal from 'sweetalert2'


  const firebaseConfig = {
    apiKey: "AIzaSyDHYl0WYOlyq4fglpu3uZqV1LAuv6_5QvM",
    authDomain: "to-do-list-app-7aa20.firebaseapp.com",
    projectId: "to-do-list-app-7aa20",
    storageBucket: "to-do-list-app-7aa20.appspot.com",
    messagingSenderId: "388979404562",
    appId: "1:388979404562:web:e4df2225ac4d9b96408dcb"
  };
  initializeApp(firebaseConfig)




function AddTask(name) {
  const [taskName , setTaskName] = useState('')
  const [taskDescription , setTaskDescription] = useState('')


    // init services
  const db = getFirestore()
  // collection Ref
  const colRef = collection(db , `${window.localStorage.getItem("Name")}-targets`)

  const handleAddTask = e => {
      e.preventDefault() 
    if(taskName === '' || taskDescription === ''){
      return  null ,
      Swal.fire({
        text : "لا معلش الاتنين لازم يتكتب فيهم" ,
        imageUrl : "https://c.tenor.com/pDZfJQ1IMAkAAAAC/khaled-el-sawy-el-basha-telmiz-movie.gif" ,
      })
    }else{
      try {
        addDoc(colRef , {
          Target : taskName ,
          Description : taskDescription,
          inProgress : true , 
          deleted : false , 
          delayed : false ,
          finished : false,
        }).then(() => {
          window.location.assign('/progress')
        })
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error
        })
      }
    }
  }
  return (
    <React.Fragment>
      <div className="addform">
        <form className="content" id='addTaskForm'>
          <h3>New Task</h3>
          <label htmlFor="name">Target:</label>
          <input type="text" placeholder='Example : React' dir='auto' value={taskName} onChange={(e) => setTaskName(e.target.value)} id='name'/>
          <label htmlFor="desc">Your Steps:</label>
          <textarea placeholder='How to finish it ....' dir='auto' value={taskDescription} onChange={(e) => setTaskDescription(e.target.value)} id='desc' />
          <button onClick={handleAddTask} >Add</button>
          <h5>والله المستعان علي ماتصفون</h5>
        </form>
      </div>
    </React.Fragment>
  )
}

export default AddTask